import React from 'react';
import NewsletterForm from '../NewsletterForm';

export default function Newsletter({ title, subTitle }) {
  return (
    <div className="cs_newsletter">
      <h2 className="cs_newsletter_title">{title}</h2>
      <div className="cs_newsletter_subTitle">{subTitle}</div>
      <div className='mt-3'>
        <NewsletterForm
          btnText="Subscribe"
          btnArrowUrl="/images/icons/arrow_white.svg"
        />
      </div>
    </div>
  );
}
